import config from '../config.general';
import { getAuFinancialYear, getUserOfficeCountry } from '../lib/utils';
import { UserOfficeCountries } from './enums';

export const getApiDomain = () => config.apiDomain;

export const getBlobStorageRootUrl = () => config.blobStorageRootUrl;

export const getPrivacyPolicyLink = () => {
	const userCountry = getUserOfficeCountry();
	switch (userCountry) {
		case UserOfficeCountries.US:
			return 'https://www.kellypartners.com/privacy-policy';
		case UserOfficeCountries.AU:
		default: // default to AU
			return 'https://www.kellypartners.com.au/privacy-policy';
	}
};

export const getTermsOfBusinessLink = () => {
	const userCountry = getUserOfficeCountry();
	switch (userCountry) {
		case UserOfficeCountries.US:
			return 'https://www.kellypartners.com/terms-of-business';
		case UserOfficeCountries.AU:
		default: // default to AU
			return 'https://www.kellypartners.com.au/terms-of-business';
	}
};

export const checkIfAU = () => {
	const userCountry = getUserOfficeCountry();
	switch (userCountry) {
		case UserOfficeCountries.US:
			return false;
		case UserOfficeCountries.AU:
		default: // default to AU
			return true;
	}
};

export const getCurrentFinancialYear = (officeCountry: string): string => {
	const today = new Date();
	const currentYear = today.getFullYear();

	switch (officeCountry) {
		case UserOfficeCountries.US:
			return `${currentYear}`;
		case UserOfficeCountries.AU:
		default: // default to AU
			return getAuFinancialYear();
	}
};
